import React from "react";
import NewFiling from "./NewFiling";
import TaxType from "./TaxType";
import { useSearchParams } from "react-router-dom";

function FilingDetails({ filingData, allowServiceData, onNext, isNewFiling }) {
  let [searchParams] = useSearchParams();
  let allowCreation = searchParams.get("drafts") === null;
  if (isNewFiling) {
    return (
      <NewFiling
        allowServices={allowServiceData}
        onNext={allowCreation ? onNext : undefined}
        filingData={filingData}
      />
    );
  } else {
    return (
      <TaxType
        filing={filingData}
        allowServices={allowServiceData}
        onNext={onNext}
      />
    );
  }
}

export default FilingDetails;
